var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2640.000000pt",
    height: "1829.000000pt",
    viewBox: "0 0 2640.000000 1829.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1829.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8725 18273 c-776 -46 -1391 -146 -2053 -333 -1382 -390 -2616 -1080 -3712 -2074 -92 -84 -490 -485 -582 -586 -684 -758 -1243 -1627 -1638 -2550 -438 -1022 -677 -2075 -730 -3210 -6 -136 -10 -1918 -10 -4862 l0 -4648 123 0 c155 0 451 16 677 36 2905 256 5526 1902 7037 4419 296 493 572 1074 759 1600 l29 80 3 -3069 2 -3069 238 6 c1978 55 3879 748 5429 1979 533 424 1028 917 1450 1443 618 772 1092 1605 1444 2540 l64 170 3 -3068 2 -3067 128 0 c264 1 688 31 1032 75 1736 222 3389 954 4740 2099 505 428 998 950 1396 1481 793 1055 1341 2245 1623 3525 84 378 142 760 188 1235 16 168 18 500 20 5019 l3 4839 -257 -6 c-1049 -26 -2141 -253 -3122 -649 -1023 -412 -1920 -976 -2765 -1738 -105 -94 -528 -520 -633 -636 -759 -845 -1343 -1801 -1754 -2869 l-88 -230 -1 3063 0 3062 -155 0 c-676 0 -1577 -131 -2299 -335 -821 -231 -1626 -586 -2356 -1038 -1711 -1060 -3052 -2700 -3756 -4592 l-63 -170 -1 3068 0 3067 -182 -2 c-101 -1 -205 -3 -233 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d56bdabc6228a715950660c5958b7f3d.svg";
export { ForwardRef as ReactComponent };